import instance, { ADMIN_PREFIX } from 'services/api';

export interface ChatHistoryRow {
  id: number;
  title: string | null;
  finished: boolean | null;
  session_id: string;
  created_at: string;
  user: { id: number; email: string } | null;
}

export interface ChatHistoryListResponse {
  results: ChatHistoryRow[];
  total: number;
}

export interface ChatMessageDoctor {
  id: number;
  first_name: string;
  last_name: string;
  avatar: string | null;
  slug: string;
  organization: {
    id: number;
    name: string;
    image: string | null;
  };
}

export interface ChatMessage {
  question: string;
  answer: string;
  doctors: ChatMessageDoctor[];
}

export interface ChatDetail {
  id: number;
  title: string | null;
  finished: boolean | null;
  session_id: string;
  created_at: string;
  messages: ChatMessage[] | null;
}

export interface FetchChatHistoryParams {
  page: number;
  limit: number;
  finished?: boolean;
}

export const fetchChatHistory = (params: FetchChatHistoryParams) =>
  instance.get<ChatHistoryListResponse>(
    `${ADMIN_PREFIX}/chat-gpt/history/admin`,
    { params }
  );

export const fetchChatById = (id: string | number) =>
  instance.get<ChatDetail>(`${ADMIN_PREFIX}/chat-gpt/history/${id}`);
